import { Component, HostBinding, OnDestroy } from '@angular/core';
import { UtilityService } from '@mono-repo/util';
import { environment } from '../../../environments_mc';
import { TranslateService } from '@mono-repo/util';
import { PageContainer } from '../../cockpit/_shared/page-container/page-container';
import { HeaderService } from '../../cockpit/_shared/header/header.service';

@Component({
  selector: 'app-update-required',
  templateUrl: './update-required.component.html',
})
export class UpdateRequiredComponent extends PageContainer {
  @HostBinding('class') class = 'dt-error dt-c-interactive-dialog type:updateRequired';
  public userId: string;
  public pageHeading: string;
  public pageSubheading: string;

  constructor(
    headerService: HeaderService,
    translateService: TranslateService,
    private utilityService: UtilityService,
  ) {
    super(headerService, translateService);
  }
  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }

  onUpdateButtonClicked() {
    // The Android Link is an https link because it seems to open the playstore anyways. The IOS 'native' link for opening the App Store page seems to work. This can also be changed a https link if needed.
    this.utilityService.openExternalLink(
      null,
      `market://details?id=${environment.androidPackageName ? environment.androidPackageName : environment.applicationId}`,
      `itms-apps://itunes.apple.com/app/${environment.applicationIosId}`,
    );
  }
}
